import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import BylineWithHeadshot from '@components/BylineWithHeadshot';
import ProExclusiveLogo from '@components/ProExclusiveLogo';
import ProjectTitle from '@components/ProjectTitle';
import { Project } from '@interfaces/projects';
import { ACCESS_PRO } from '@src/constants';

type TopSectionProps = Pick<
  Project,
  'accessLevel' | 'authors' | 'description' | 'title' | 'titleCallout'
>;

const TopSection = ({
  accessLevel,
  authors,
  description,
  title,
  titleCallout,
}: TopSectionProps): JSX.Element => {
  const titleWithoutCallout = title.replace(titleCallout, '').trim();

  return (
    <div className="px-16">
      <div className="mx-auto w-[1040px] max-w-full">
        {accessLevel >= ACCESS_PRO && <ProExclusiveLogo />}
        <ProjectTitle className="!mb-16" title={titleWithoutCallout} titleCallout={titleCallout} />
        {authors?.length > 0 && (
          <div className="flex justify-center">
            <BylineWithHeadshot
              authors={authors}
              className="font-suisse-screen text-byline-sm text-primary-black sm:text-byline-lg"
            />
          </div>
        )}
        <p className="mx-auto w-full md:mt-64 md:w-3/4">{ReactHtmlParser(description)}</p>
      </div>
    </div>
  );
};

export default TopSection;
